import { ClientsService } from './../../../shared/services/clients.service';
import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { UiService } from '@services/ui.service';
import { Client } from '@classes/client';
import { ContainersService } from '@services/containers.service';
import { Container } from '@classes/container';
import { ProductTypesService } from '@services/productTypes.service';
import { ProductType } from '@classes/productType';
import { VehiclesService } from '@services/vehicles/vehicles.service';
import { Vehicle } from '@classes/vehicles/vehicle';

@Component({
  selector: 'app-container-edit',
  templateUrl: './container-edit.component.html',
  styleUrls: ['./container-edit.component.scss']
})
export class ContainerEditComponent extends FormEditBaseComponent implements OnInit {
  @Input() container: Container;
  clients: Client[];
  productTypes: ProductType[];
  vehicles: Vehicle[];

  stringMaxLength = 50;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private clientsSrv: ClientsService,
    private containersSrv: ContainersService,
    private productTypesSrv: ProductTypesService,
    private vehiclesSrv: VehiclesService
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initSub();
  }

  initSub(): void {
    this.isLoading = true;

    const clientsPromise = new Promise((resolve) => {
      this.clientsSrv.getList()
        .subscribe(clientsFromSrv => {
          this.clients = clientsFromSrv;
          resolve(true);
        });
    });

    const productTypesPromise = new Promise((resolve) => {
      this.productTypesSrv.getList()
        .subscribe(productTypesFromSrv => {
          this.productTypes = productTypesFromSrv;
          resolve(true);
        });
    });

    const vehiclesPromise = new Promise((resolve) => {
      this.vehiclesSrv.getList().subscribe(vehicles => {
        this.vehicles = vehicles;
        resolve(true);
      })
    });

    Promise.all([clientsPromise, productTypesPromise, vehiclesPromise])
      .then(() => {
        this.isLoading = false;
        this.initForm();
      });
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.container) {
      this.update();
    } else {
      this.create();
    }
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.onSubmit();
    } else {
      this.onCancel();
    }
  }

  private update(): void {
    const containerCopy: Container = JSON.parse(JSON.stringify(this.container));
    containerCopy.client = this.editForm.value.client;
    containerCopy.description = this.editForm.value.description;
    containerCopy.identifier = this.editForm.value.identifier;
    containerCopy.tag = this.editForm.value.tag;
    containerCopy.productType = this.editForm.value.productType;
    containerCopy.vehicle = this.editForm.value.vehicle;

    this.containersSrv.put(containerCopy).subscribe(() => this.isLoading = false);
  }

  private create(): void {
    this.container = new Container(
      this.editForm.value.client,
      this.editForm.value.description,
      this.editForm.value.identifier,
      this.editForm.value.tag,
      this.editForm.value.productType
    );

    this.container.vehicle = this.editForm.value.vehicle;

    this.containersSrv.post(this.container)
      .subscribe(
        () => this.isLoading = false,
        () => this.container = null
      );
  }

  private initForm(): void {
    let client = null;
    let description = null;
    let identifier = null;
    let tag = null;
    let productType = null;
    let vehicle = null;

    if (this.container) {
      client = this.container.client || null;
      description = this.container.description || null;
      identifier = this.container.identifier || null;
      tag = this.container.tag || null;
      productType = this.container.productType || null;
      vehicle = this.container.vehicle || null;
    }

    this.editForm = this.fb.group({
      client: [client, Validators.required],
      description: [description, [Validators.required, Validators.maxLength(this.stringMaxLength)]],
      identifier: [identifier, [Validators.required, Validators.maxLength(this.stringMaxLength)]],
      tag: [tag, [Validators.required, Validators.maxLength(this.stringMaxLength)]],
      productType: [productType, [Validators.required]],
      vehicle: [vehicle]
    });
  }
}
